import React, { Component, Fragment } from 'react';
import Modal from '../../components/UI/Modal/Modal.jsx';
import Button from '../../components/UI/Button/Button.jsx';

const withErrorHandler = (WrappedComponent, axios) => {
  return class extends Component {

    state = {
      error: null
    }

    constructor(props) {
      super(props);
      this.requestInterceptor = axios.interceptors.request.use(req => {
        this.setState({ error: null });
        return req;
      })
      this.responseInterceptor = axios.interceptors.response.use(res => res, error => {
        this.setState({ error: error });
      })
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.requestInterceptor);
      axios.interceptors.response.eject(this.responseInterceptor);
    }

    errorConfirmedHandler = () => {
      this.setState({ error: null })
    }

    render() {

      return (
        <Fragment>
          <Modal
            show={this.state.error ? true : false}
            error={this.state.error ? true : false}
            clicked={this.errorConfirmedHandler}>
            <h2>Error</h2>
            <br />
            <p>{this.state.error ? this.state.error.message : null}</p>
            <br />
            <Button btnType={'Neutral'} clicked={this.errorConfirmedHandler} > Okay
            </Button>
          </Modal>
          <WrappedComponent {...this.props} />

        </Fragment>
      )
    }
  }
}
export default withErrorHandler;


// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler/withErrorHandler.jsx